export const enumsGetters = {
  allEnums: (state) => state.allEnums,
  getEnumByName: (state) => (name) => {
    return state.allEnums.find((item) => item.enumName === name);
  },
};
